export const capitalize = (title) => {
    let str = title;

    if(str){
        str = str.split(" ").map(e => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase()).join(" ");
    }

    return str;
}

export const nameInitials = (name) => {
    let str = name;
    let final = "";

    if(str){
        str = str.split(" ");

        str.forEach((element, index) => {
            if(index < 2){
                final = final + String(element).charAt(0);
            }
        });
    }

    return final;
}